import React, { useState } from "react";
import "./cards.scss";
import ModelPanel from "../ModelPanel";


export default function Cards(props) {
  const [isOpen, setIsOpen] = useState(false);

  const openHandle = () => {
    setIsOpen(true);
  };

  return (
    <div className="card-sec">
      <div className="card-content">
        <div className="back">
          <div className="back-content">
            <img src={props.images} alt="Card cover" className="card-image" />

            <div className="card-overlay">
              <div className="card-des">
                <h1>{props.heading}</h1>
                <span className="content-badge">{props.tag}</span>
                <a href={props.url} target="_blank" rel="noopener noreferrer" className="view-icon">View site</a>
                {/* <button className="view-icon" onClick={openHandle}>View site</button> */}
              </div>
            </div>
          </div>
        </div>
      </div>

      <ModelPanel open={isOpen} onClose={() => setIsOpen(false)} data={props} />
    </div>
  );
}
